"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _Theme = require("../Theme");

var _index = require("../index");

var __jsx = _react["default"].createElement;

var _default = function _default(props) {
  var _props$sx = props.sx,
      sx = _props$sx === void 0 ? {} : _props$sx,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 12 : _props$cols,
      _props$gap = props.gap,
      gap = _props$gap === void 0 ? "gridGap" : _props$gap,
      rowGap = props.rowGap,
      minItemWidth = props.minItemWidth,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "cols", "gap", "rowGap", "minItemWidth"]);
  var theme = (0, _Theme.useTheme)();

  if (typeof rowGap === "undefined" || rowGap === null) {
    rowGap = gap;
  }

  var gridTemplateColumns = (0, _index.responsiveValueMap)(cols, function (x) {
    return typeof x === "number" ? "repeat(".concat(x, ", 1fr)") : x;
  });

  if (minItemWidth) {
    gridTemplateColumns = (0, _index.responsiveValueMap)(minItemWidth, function (x) {
      return "repeat(auto-fill, minmax(".concat(typeof x === "number" ? "".concat(x, "px") : x, ", 1fr))");
    });
  }

  return __jsx(_Box["default"], (0, _extends2["default"])({
    sx: (0, _objectSpread2["default"])({
      display: "grid",
      gridColumnGap: gap,
      gridRowGap: rowGap,
      gridTemplateColumns: gridTemplateColumns
    }, sx)
  }, restProps));
};

exports["default"] = _default;